import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/membershipFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'sancElectricity',
    type: 'text',
    label: 'Electricity (KW/Hour)',
  },
  {
    colSpan: 1,
    name: 'sancGas',
    type: 'text',
    label: 'Gas (Cubic Meters)',
  },
];

export const sanctionLoadFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label).nullable(),
  [fields[1].name]: yup.string().label(fields[1].label).nullable(),
};

const SanctionLoad = (props) => {
  return (
    <FormSection sectionName="Sanction Load" sectionColumn={2} formFields={fields} {...props} />
  );
};

export default SanctionLoad;
